var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"loading-panel"},[_c('loading-animation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }